import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleCreateOrganizationalUnitSuccess(
  resource: Identifiable<Resource>,
  { organizationalUnit }: Boundaries["createOrganizationalUnit"]["success"],
): Identifiable<Resource> {
  const assignedResource = organizationalUnit.resources?.find(
    ({ uuid }) => uuid === resource.uuid,
  );

  return assignedResource
    ? { ...resource, organizationalUnit: assignedResource.organizationalUnit }
    : resource;
}

export { handleCreateOrganizationalUnitSuccess };
